import { UnlockIllustration } from '@carboncopyco/illustrations';
import { Button, ErrorBox } from '@carboncopyco/ui';

type NoAccessPageProps = {
  access: 'org' | 'workspace';
  action?: () => void;
};

const workspaceAccessText =
  "You don't have access to this page. Please ask your admin for workspace access and try again.";
const orgAccessText =
  'It seems you do not have access to this page. Please ensure you have access to this organization, and then try again.';

export const AccessDeniedPage = ({ access, action }: NoAccessPageProps) => {
  return (
    <ErrorBox
      illustration={<UnlockIllustration />}
      title="Access required"
      message={access === 'workspace' ? workspaceAccessText : orgAccessText}
      buttons={
        action && (
          <Button
            label="Go to homepage"
            onClick={action}
          />
        )
      }
    />
  );
};
